import { required, email, is, max, min, max_value, confirmed, digits, regex, size, alpha_num } from 'vee-validate/dist/rules';
import { extend, setInteractionMode } from 'vee-validate';
import i18n from '../../locales/i18n.js';
setInteractionMode('eager');

extend('required', {
	...required,
	message: i18n.t('inputRules.requiredField')
});

extend('day', {
	...regex,
	message: 'day should be of  1-31'
});

extend("maxSize", {
	...size,
	message: i18n.t('inputRules.fileLengthWarning')
})

extend('max', {
	...max,
	message: max => `This may not be greater than ${max} characters`
});

extend("phone", {
	...digits,
	message: "Phone number should be of 8 digits",
});
extend('regex', {
	...regex,
	message: 'Currency rate should be digits'
});
extend('field', {
	...regex,
	message: 'Special charecters are not allowed'
});
extend('email', {
	...email,
	message: i18n.t('inputRules.validEmail')
});


extend('minPhone', {
	...min,
	message: i18n.t('inputRules.number')
});
extend('maxPhone', {
	...max,
	message: i18n.t('inputRules.number')
});

extend('minPass', {
	...min,
	message: i18n.t('inputRules.min_pass_6')
});

extend('maxPass', {
	...max,
	message: i18n.t('inputRules.max_pass_20')
});

extend('confirmed', {
	...confirmed,
	message: i18n.t('inputRules.pass_not_match')
});

extend('minName', {
	...min,
	message: i18n.t('inputRules.min_name_3')
});

extend('minIban', {
	...min,
	message: i18n.t('inputRules.min_iban_10')
});
extend('civilId', {
	...min,
	message: i18n.t('inputRules.min_civil_12')
});

extend('maxValue', {
	...max_value,
	message: i18n.t("inputRules.valueNotAllowed")
})
extend('name', {
	...regex,
	message: 'name should be alphabets'
});
extend("confirmed", {
	...confirmed,
	message: "Password must be same",
});

extend("isNumber", {
	validate(value) {
		return !isNaN(value)
	},
	message: "Invalid Value"
})

extend("notSpecialChars", {
	...alpha_num,
	message: "Special Characters Not Allowed"
})
extend('ibanLength', {
	validate(value) {
		return value.length === 10
	},
	message: i18n.t('inputRules.min_iban_10')
});

extend('sameAs', {
	...is,
	message: i18n.t('core.passwordsMustSame')
})


extend('arabicText', {
	validate: value => {
		if (!value) return true;
		return /^[\u0600-\u06FF\s\0-9٠-٩.,،:؛؟!]+$/.test(value);
	},
	message: i18n.t('inputRules.arabicText')
});